import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 无触摸点环境或 PC 微信：将鼠标映射为 touch，使 Vant 仅监听 touch 的组件（如 van-number-keyboard）可点击。
// PC 微信偶发 maxTouchPoints 非 0，故用 UA 兜底。
if (typeof navigator !== 'undefined') {
  const ua = navigator.userAgent || ''
  const pcWeChat = /micromessenger/i.test(ua) && !/android|iphone|ipad|ipod|webos|blackberry|mobile/i.test(ua)
  if (navigator.maxTouchPoints === 0 || pcWeChat) {
    require('@vant/touch-emulator')
  }
}

// 引入全局子组件
import FootNav from './components/footnav/FootNav'
import Vant from 'vant';
import 'vant/lib/index.css';
import api from './http/api';
import publicJs from './publicJs/com';
import utils from './utils';
import './config/rem'  //px转rem，防止微信字体设置影响
import { Notify } from 'vant';
import { IndexBar, IndexAnchor } from "vant";
import { Checkbox, CheckboxGroup } from 'vant';
import { Overlay } from 'vant';
import { Toast } from 'vant';
import { Dialog } from 'vant';
import { post, get, patch, put } from './http'
import loading from './components/loading.vue'
import { Tab, Tabs } from 'vant';
import VueClipboard from 'vue-clipboard2'

import waterfall from 'vue-waterfall2'
Vue.use(waterfall)
// import VideoPlayer from 'vue-video-player'
// require('vue-video-player/src/custom-theme.css')
// require('video.js/dist/video-js.css')
//引入
import moment from 'moment';
var VueTouch = require('vue-touch')
Vue.use(Tab).use(Tabs);
Vue.use(Overlay);
// Vue.use(VideoPlayer)
// 懒加载
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad, {
  preLoad: 1,
  // error: require('./assets/images/logo_loading.jpg'),
  // loading: require('./assets/images/imgLoading.gif'),
  attempt: 2,
})
import VueSignature from "vue-signature-pad";
Vue.use(VueSignature);
Vue.use(Notify);
Vue.use(VueTouch, { name: 'v-touch' })
// 把api挂载成全局变量
Vue.prototype.$Toast = Toast
Vue.prototype.$api = api
Vue.prototype.$Dialog = Dialog
Vue.prototype.$Toast = Toast
Vue.prototype.$publicJs = publicJs
Vue.prototype.$utils = utils
// 定义全局变量
Vue.prototype.$post = post
Vue.prototype.$get = get
Vue.prototype.$patch = patch
Vue.prototype.$put = put
//挂载到原型
Vue.prototype.$moment = moment;
//汉化，否则显示日期格式是国外的日期格式
moment.locale("zh-CN");
// 注册全局组件
Vue.component('FootNav', FootNav)
Vue.component('loading', loading)
// \注册地址
Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(Vant);
Vue.use(Dialog);
Vue.config.productionTip = false
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(VueClipboard)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
